import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import { useAuth } from "../../contexts/AuthContext";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
import DropDownSpecificStaff from "../Dropdowns/DropDownSpecificStaff";

import Chip from "@mui/material/Chip";

function AddEndOfShiftNote(props) {
  const { currentUser } = useAuth();
  const [note, setNote] = useState("");
  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());
  const [selectedStaff, setSelectedStaff] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [endOfShiftNoteDateTime, setEndOfShiftNoteDateTime] = useState(
    new Date()
  );
  const draftKey = `draft:endOfShiftNote:${currentUser?.uid || "anon"}:${
    props.clientId || "global"
  }`;
  const draftDelay = 800;
  const [isSavingDraft, setIsSavingDraft] = useState(false);

  const isFormValid =
    note && startTime && endTime && selectedStaff && endOfShiftNoteDateTime;

  const handleEndOfShiftNoteDateTimes = (event) => {
    setEndOfShiftNoteDateTime(event);
  };

  // useEffect(() => {
  //   recordMetrics(
  //     "Notes",
  //     "endOfShiftNotes",
  //     currentUser.email,
  //     "write",
  //     "bodhi"
  //   );
  // }, []);

  const handleNoteChange = (event) => {
    setNote(event.target.value);
  };

  const handleStartTimeChange = (event) => {
    setStartTime(event);
  };

  const handleEndTimeChange = (event) => {
    setEndTime(event);
  };

  const handleStaffChange = (selectedStaff) => {
    setSelectedStaff(selectedStaff);
  };

  // Restore draft on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(draftKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.note) setNote(parsed.note);
        if (parsed?.startTime) {
          const d = new Date(parsed.startTime);
          if (!isNaN(d)) setStartTime(d);
        }
        if (parsed?.endTime) {
          const d = new Date(parsed.endTime);
          if (!isNaN(d)) setEndTime(d);
        }
        if (parsed?.selectedStaff) setSelectedStaff(parsed.selectedStaff);
        if (parsed?.effectiveDateTime) {
          const d = new Date(parsed.effectiveDateTime);
          if (!isNaN(d)) setEndOfShiftNoteDateTime(d);
        }
      }
    } catch (e) {
      console.warn("EndOfShift draft load error:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autosave draft with debounce
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem(
          draftKey,
          JSON.stringify({
            note,
            startTime: startTime?.toISOString?.() || null,
            endTime: endTime?.toISOString?.() || null,
            selectedStaff,
            effectiveDateTime: endOfShiftNoteDateTime?.toISOString?.() || null,
          })
        );
        setIsSavingDraft(false);
      } catch (e) {
        console.warn("EndOfShift draft save error:", e);
      }
    }, draftDelay);
    setIsSavingDraft(true);
    return () => clearTimeout(t);
  }, [
    note,
    startTime,
    endTime,
    selectedStaff,
    endOfShiftNoteDateTime,
    draftKey,
  ]);

  const handleSubmit = async () => {
    if (!isFormValid) {
      showCustomToast("Please fill all required fields", "error");
      return;
    }

    setIsLoading(true);
    const noteData = {
      noteType: "endOfShift",
      noteContent: note,
      shiftStart: startTime,
      shiftEnd: endTime,
      staff: selectedStaff,
      createdAt: serverTimestamp(),
      doneBy: currentUser.displayName,
      effectiveDateTime: endOfShiftNoteDateTime,
    };

    try {
      await addDoc(collection(db, "notes"), noteData);
      showCustomToast("End of Shift Note successfully added!", "success");
      try {
        localStorage.removeItem(draftKey);
      } catch {}
      props.closemodal();
    } catch (error) {
      console.error("Error adding End of Shift Note:", error);
      showCustomToast("Error when adding End of Shift Note", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ width: "auto", height: "100%" }}>
      <div className="line1-modal-percent">
        <div className="modal-title">Add End Of Shift Note</div>
        <CloseIcon
          style={{
            marginRight: "16px",
            color: "rgb(214, 213, 213)",
            cursor: "pointer",
          }}
          onClick={props.closemodal}
        />
      </div>

      <div
        style={{
          width: "100%",
          marginTop: "0px",
          height: "75%",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <div className="line2-column-modal-bis">
          <div className="label-textfield">Note</div>
          <TextField
            value={note}
            onChange={handleNoteChange}
            style={{
              width: "95%",
              borderRadius: "5px",
              backgroundColor: "#f2eeef",
            }}
            placeholder="Type your note here"
            multiline
            rows={12}
          />
        </div>
        <div
          className="line3-modal-nopad"
          style={{ paddingLeft: "20px", marginBottom: "20px" }}
        >
          <DatePickerWithTimeComponent
            value={startTime}
            onChange={handleStartTimeChange}
            title="Start of Shift"
          />
          <DatePickerWithTimeComponent
            value={endTime}
            onChange={handleEndTimeChange}
            title="End of Shift"
          />
          <DropDownSpecificStaff
            value={selectedStaff}
            onChange={handleStaffChange}
            title="Select Staff"
          />
        </div>

        <div
          className="textfield-and-label-container"
          style={{
            // marginLeft: "20px",
            paddingLeft: "20px",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <DatePickerWithTimeComponent
            value={endOfShiftNoteDateTime}
            onChange={handleEndOfShiftNoteDateTimes}
            title="Effective date and time"
          />
        </div>
      </div>

      <div
        className="line4-modal-percent"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 10,
        }}
      >
        <Chip
          label={
            isSavingDraft
              ? "Saving draft..."
              : note || selectedStaff
              ? "Draft saved"
              : "No draft"
          }
          size="small"
          sx={{
            backgroundColor: isSavingDraft
              ? "#f9a825"
              : note || selectedStaff
              ? "#2e7d32"
              : "#607d8b",
            color: "#fff",
            fontWeight: 700,
          }}
        />
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            try {
              localStorage.removeItem(draftKey);
            } catch {}
            setNote("");
            setStartTime(new Date());
            setEndTime(new Date());
            setSelectedStaff("");
            setEndOfShiftNoteDateTime(new Date());
          }}
        >
          Clear draft
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "white", color: "black", marginRight: 10 }}
          onClick={props.closemodal}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={!isFormValid || isLoading}
          variant="contained"
          style={
            isLoading
              ? { backgroundColor: "grey" }
              : { backgroundColor: "#1565C0", color: "white" }
          }
        >
          {isLoading ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </div>
  );
}

export default AddEndOfShiftNote;
